import * as Sentry from "@/utils/logger.util";

let auth2: any;

declare global {
  interface Window {
    gapi: any;
    onGapiLoad: any;
  }
}

export interface GoogleAuthConfig {
  client_id: string | undefined;
}

export interface GoogleApiResult {
  getAuthResponse: () => {
    token_type: string;
    login_hint: string;
    expires_in: number;
    id_token: string;
  };
  uc: {
    access_token: string;
  };
}

export interface GoogleAuthResult {
  token_type: string;
  login_hint: string;
  expires_in: number;
  id_token: string;
  access_token: string;
}

const createScript = (params: GoogleAuthConfig) => {
  return new Promise((resolve, reject) => {
    const el = document.getElementById("auth2_script_id");
    if (!el) {
      window.onGapiLoad = () => {
        window.gapi.load("auth2", () => {
          try {
            auth2 = window.gapi.auth2.init(Object.assign({}, params));
          } catch (err) {
            Sentry.captureException(err);
            reject({
              err:
                "client_id missing or is incorrect, or if you added extra params maybe they are written incorrectly, did you add it to the component or plugin?"
            });
          }
          resolve(auth2);
        });
      };
      let gplatformScript = document.createElement("script");
      gplatformScript.setAttribute("src", "https://apis.google.com/js/platform.js?onload=onGapiLoad");
      gplatformScript.setAttribute("async", "true");
      gplatformScript.setAttribute("defer", "defer");
      gplatformScript.setAttribute("id", "auth2_script_id");
      document.head.appendChild(gplatformScript);
    }
    resolve();
  });
};

export const load = (params: GoogleAuthConfig) => {
  return createScript(params);
};

export const signIn = async () => {
  const result: GoogleApiResult = await auth2.signIn();
  console.log({ auth2 });

  const { access_token = "" } = window.gapi.auth2
    .getAuthInstance()
    .currentUser.get()
    .getAuthResponse(true);
  return {
    ...result.getAuthResponse(),
    access_token
  };
};

export const signOut = async () => await auth2.signOut();
